import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "../src/styles/style.css";
import "./App.css";
import AddJob from "./Component/AddJob/AddJob";
import AvailableJobs from "./Component/AvailableJobs/AvailableJobs";
import EditJob from "./Component/EditJob/EditJob";
import Navbar from "./Component/Navbar/Navbar";
import Layout from "./Layout/Layout";

function App() {
  return (
    <BrowserRouter>
      <Navbar></Navbar>
      <Routes>
        <Route path="/" element={<Layout></Layout>}>
          <Route path="/" element={<AvailableJobs></AvailableJobs>}>
            <Route></Route>
          </Route>
          <Route path="/addJob" element={<AddJob></AddJob>}></Route>
          <Route path="/editJob/:jobId" element={<EditJob></EditJob>}></Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
